module.exports = __webpack_public_path__ + "static/media/Morris-logo-640x497.126094a3.jpg";